import { i18n } from '@apps/main/modules/localization/localizationSetup';

import type { PortStaticInfo } from '@libs/trip-planner-interfaces';
import { IngredientType } from '@libs/trip-planner-interfaces';
import { DateFormat, SemboDate } from '@libs/sembo-dates';

import type {
  MultiIngredientBookableTransportCard,
  PeekPriceSmallBookableTransportCardData,
} from '../models';
import { PeekPriceModalCardType } from '../models';

const { t } = i18n.global;

export function getMultiIngredientBookableTransportCardLoadingData(
  ingredientType: IngredientType
): MultiIngredientBookableTransportCard {
  const isFlight = ingredientType === IngredientType.Flight;
  const data: PeekPriceSmallBookableTransportCardData = {
    date: undefined,
    stops: undefined,
    carrierLogoUrl: undefined,
    carrierLogoAltText: isFlight
      ? t('a11y.flight_carrier_logo')
      : t('a11y.ferry_carrier_logo'),
    altLogoIcon: isFlight ? 'airplane' : 'ferry',
    time: undefined,
    ports: undefined,
  };
  return {
    type: PeekPriceModalCardType.BookableTransport,
    data,
  };
}

export function getStopsText(numberOfStops: number): string {
  return numberOfStops === 0
    ? t('planner.direct_flight_short')
    : t('planner.number_of_stops', [numberOfStops], numberOfStops);
}

export function getPortsText(
  departurePort: PortStaticInfo,
  arrivalPort: PortStaticInfo
): string {
  return `${departurePort.position.name} (${departurePort.code}) - ${arrivalPort.position.name} (${arrivalPort.code})`;
}

export function getTimeText(departure: Date, arrival: Date): string {
  return `${new SemboDate(departure).format(DateFormat.Time)} - ${new SemboDate(
    arrival
  ).format(DateFormat.Time)}`;
}
